(function () {
  function log() {
    if (typeof console !== "undefined" && console.log) {
      console.log.apply(console, ["[convert-product-v2]", ...arguments]);
    }
  }

  function openAlgoliaSearch() {
    const detachedBtn = document.querySelector(
      ".aa-Autocomplete .aa-DetachedSearchButton"
    );

    if (detachedBtn) {
      detachedBtn.click();
      return;
    }

    const input = document.querySelector(".aa-Input");

    if (input) {
      input.focus();
      input.value = " ";
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.value = "";
      log("Algolia search opened via input");
    }
  }

  function patchSearchIcon() {
    const icon = document.querySelector(
      "header#SiteHeader .header-item--icons .convert-product-v2-search-button"
    );

    if (!icon || icon.classList.contains("v2_done")) return;

    icon.classList.add("active", "v2_done");
    icon.addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      openAlgoliaSearch();
    });

    log("Search icon patched");
  }

  function initConvertProductV2Search() {
    patchSearchIcon();

    const header = document.querySelector("#SiteHeader");
    if (header && !header.dataset.v2SearchObserving) {
      header.dataset.v2SearchObserving = "true";
      new MutationObserver(patchSearchIcon).observe(header, {
        childList: true,
        subtree: true,
      });
    }
  }

  function onReady() {
    initConvertProductV2Search();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  document.addEventListener("algoliaShopify:initialized", patchSearchIcon);
  document.addEventListener("page:loaded", initConvertProductV2Search);
})();
